import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, Modal as ModalComponent, Button, SpanLink } from '@tvg/fuse-design';

const DialogContent = styled.div`
  display: block;
  justify-content: center;
  text-align: center;
  margin: auto;
  max-width: 285px;
`;
const ErrorLink = styled(SpanLink)`
  padding-top: 20px;
`;

const ErrorButton = styled(Button)`
  max-width: 218px;
`;
interface Props {
  open: boolean;
  closeDialog: () => void;
  onCancelCallback: () => void;
  onCloseCallback: () => void;
  onReloadCallback: () => void;
}

function ErrorDialog(props: Props) {
  const { open, closeDialog, onCancelCallback, onCloseCallback, onReloadCallback } = props;

  const reloadPage = () => window.location.reload();

  const onCancelCallbackHandler = (e: MouseEvent) => {
    e.preventDefault();
    closeDialog();
    onCancelCallback();
  };

  const onCloseCallbackHandler = () => {
    closeDialog();
    onCloseCallback();
  };

  const onReloadClickHandler = () => {
    onReloadCallback();
    reloadPage();
  };

  return (
    <ModalComponent
      name="error_dialog"
      open={open}
      onClose={onCloseCallbackHandler}
      title="Oops"
      dataTestId="error_dialog"
      srLabelCloseButton="close error dialog"
      zIndex="25"
    >
      <DialogContent>
        <TypographyElement type="paragraph" size="1" tag="p">
          It looks like we&apos;ve had a little hiccup.
        </TypographyElement>

        <ErrorButton
          onClick={onReloadClickHandler}
          data-testid="error-dialog_reload"
          size="large"
          variant="primary"
          fullWidth
        >
          Reload
        </ErrorButton>

        <ErrorLink href="#" onClick={onCancelCallbackHandler} dataTestId="error-dialog_cancel" size="medium">
          Cancel and close
        </ErrorLink>
      </DialogContent>
    </ModalComponent>
  );
}

export default ErrorDialog;
